
























































































































































































































































import {Vue, Component} from 'vue-property-decorator'
import {TabBase} from "@/views/Vozila/DetaljiVozila/TabBase";
import {NabavkaVozila} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service";

@Component({})
export default class Tab1 extends TabBase {
    nabavka = new NabavkaVozila();

    osiguranja = [];

    async created() {
        this.nabavka = await dataProxy.vratiNabavkuVozila(this.vozilo.id);
        this.osiguranja = await dataProxy.vratiPoliseVozila(this.vozilo.id);
    }
}
